import React from "react";
interface SuggestionContextProps {
  suggestions: Map<string, string[]>;
}

export const SuggestionContext = React.createContext<SuggestionContextProps>({
  suggestions: new Map<string, string[]>(),
});
